import { render, staticRenderFns } from "./create-or-edit-organiaztion-unit.vue?vue&type=template&id=7f65fdaa&scoped=true&"
import script from "./create-or-edit-organiaztion-unit.vue?vue&type=script&lang=js&"
export * from "./create-or-edit-organiaztion-unit.vue?vue&type=script&lang=js&"
import style0 from "./create-or-edit-organiaztion-unit.vue?vue&type=style&index=0&id=7f65fdaa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f65fdaa",
  null
  
)

export default component.exports